import Country from 'utils/country';

const getCountryName = (countryCode?: string | null) => {
  return Country.find((e) => e.iso === countryCode)?.country;
};

export default getCountryName;
